// Runtime feature flags served by GET /flags. Keys mirror the canonical
// registry in packages/db/src/feature-flags.ts (camelCased wire names); the
// API has no @atlas/shared dep, so keep the two in step when adding a flag.
export interface FeatureFlags {
  /** Strava partner athlete cap is full: hide connect-with-Strava UI. */
  stravaConnectionsFull: boolean;
  /** Beta gate: Stripe checkouts open the beta-access modal instead. */
  betaGate: boolean;
  /** Beta surveyor cosmetic set is still being granted (server-side only). */
  betaCosmeticsOpen: boolean;
  /** Signed-out visitors may use the route analyser (server-side gate). */
  routeAnalyserPublic: boolean;
}

export interface FeatureFlagsResponse {
  flags: FeatureFlags;
}

/** What clients assume until GET /flags has answered (or when it can't be
 *  reached): everything gated, so a dead Strava button never shows. */
export const FEATURE_FLAG_FALLBACK: FeatureFlags = {
  stravaConnectionsFull: true,
  betaGate: true,
  betaCosmeticsOpen: false,
  // The API is authoritative (anonymous requests get 503 when it is off), so
  // the client shows the page until told otherwise.
  routeAnalyserPublic: true,
};

/** Admin view of one flag (GET /flags/admin). */
export interface AdminFeatureFlag {
  key: string;
  label: string;
  description: string;
  defaultEnabled: boolean;
  enabled: boolean;
  updatedAt: string | null;
  updatedBy: string | null;
}
